import { render, staticRenderFns } from "./Individual.vue?vue&type=template&id=224f98f4&scoped=true&"
import script from "./Individual.vue?vue&type=script&lang=js&"
export * from "./Individual.vue?vue&type=script&lang=js&"
import style0 from "@/assets/hometeacher/css/main.css?vue&type=style&index=0&lang=css&"
import style1 from "./Individual.vue?vue&type=style&index=1&id=224f98f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224f98f4",
  null
  
)

export default component.exports